import { render, staticRenderFns } from "./AccountSecurity.vue?vue&type=template&id=af8750f0&scoped=true&"
import script from "./AccountSecurity.vue?vue&type=script&lang=js&"
export * from "./AccountSecurity.vue?vue&type=script&lang=js&"
import style0 from "./AccountSecurity.vue?vue&type=style&index=0&id=af8750f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8750f0",
  null
  
)

export default component.exports